import { render } from "./Banner.vue?vue&type=template&id=6f4b8373"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import exportComponent from "/home/jeim2750/fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__